import { render, staticRenderFns } from "./PSkillTagButton.vue?vue&type=template&id=7af3d2c6&scoped=true&"
import script from "./PSkillTagButton.vue?vue&type=script&lang=ts&"
export * from "./PSkillTagButton.vue?vue&type=script&lang=ts&"
import style0 from "./PSkillTagButton.vue?vue&type=style&index=0&id=7af3d2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af3d2c6",
  null
  
)

export default component.exports